export const users = [
    {
        url: "https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/dna.png",
        user: "Health Tech Vendors",
        description: "Find vendors that build apps to enable a frictionless experience for physicians.",
        link: "/explore/category/workflow-%26-productivity",
    },
    {
        url: "https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/labs.png",
        user: "Labs/Diagnostic Centers",
        description: "Connect with labs and prescription centers that can receive and process orders directly through your EHR",
        link: "/explore/essentials#labs-diagnostic-centers",
    },
    {
        url: "https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/consultant.png",
        user: "Services & Consultants",
        description: "Find consultants who provide IT or billing/revenue cycle management services to providers",
        link: "/explore/category/consultants",
    },
    {
        url: "https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/system_integrators.png",
        user: "System Integrators",
        description: "Find system integrators and migration health IT developers who can build custom tools for you.",
        link: "/explore/category/developers",
    },
    {
        url: "https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/devices.png",
        user: "Device Manufacturers",
        description: "Discover new devices and patient monitoring tools that can integrate into your workflow",
        link: "/explore/category/devices",
    },
];

// Marketplace Terms of Service (vendor/service-provider agreement), rendered in-app as a styled
// page (see src/Common/TermsOfService.js) instead of linking out to the S3-hosted PDF.
export const termsOfServiceUrl = "/terms-of-service";

export const legalLinks = [
    {
        category: 'Products',
        name: "Electronic Health Records",
        link: "https://www.charmhealth.com/ehr/"
    },
    {
        category: 'Products',
        name: "Practice Management",
        link: "https://www.charmhealth.com/practice-management/"
    },
    {
        category: 'Products',
        name: "Patient Engagement",
        link: "https://www.charmhealth.com/patient-engagement/"
    },
    {
        category: 'Products',
        name: "Telehealth",
        link: "https://www.charmhealth.com/telehealth/"
    },
    {
        category: 'Products',
        name: "Revenue Cycle Management",
        link: "https://www.charmhealth.com/revenue-cycle-management/"
    },
    {
        category: 'Products',
        name: "Medical Billing Platform",
        link: "https://www.charmhealth.com/medical-billing-platform/"
    },
    {
        category: 'Products',
        name: "Connect",
        link: "https://www.charmhealth.com/connect/"
    },
    {
        category: 'Specialties',
        name: "Family Practice",
        link: "https://www.charmhealth.com/ehr/family-practice/family-practice-emr.html"
    },
    {
        category: 'Specialties',
        name: "Internal Medicine",
        link: "https://www.charmhealth.com/ehr/internal-medicine/internal-medicine-emr.html"
    },
    {
        category: 'Specialties',
        name: "Pediatrics",
        link: "https://www.charmhealth.com/ehr/pediatrics/pediatrics-emr.html"
    },
    {
        category: 'Specialties',
        name: "Psychiatry",
        link: "https://www.charmhealth.com/ehr/psychiatry/psychiatry-emr.html"
    },
    {
        category: 'Specialties',
        name: "Integrative Medicine",
        link: "https://www.charmhealth.com/ehr/integrative-medicine/integrative-medicine-emr.html"
    },
    {
        category: 'Specialties',
        name: "Dental",
        link: "https://www.charmhealth.com/ehr/dentistry/dental-emr.html"
    },
    {
        category: 'Services',
        name: "Practice Onboarding",
        link: "https://www.charmhealth.com/ehr/training-registration.html"
    },
    {
        category: 'Services',
        name: "Online Training",
        link: "https://www.charmhealth.com/ehr/online-support-session-request.html"
    },
    {
        category: 'Services',
        name: "EMR Migration",
        link: "https://www.charmhealth.com/ehr/switch-emr.html"
    },
    {
        category: 'Services',
        name: "Lab Integration",
        link: "https://www.charmhealth.com/partner/integration/labs.html"
    },
    {
        category: 'Company',
        name: "About Us",
        link: "https://www.charmhealth.com/aboutus.html"
    },
    {
        category: 'Company',
        name: "Contact Us",
        link: "https://www.charmhealth.com/contactus.html"
    },
    {
        category: 'Learn',
        name: "Resources Center",
        link: "https://www.charmhealth.com/resources/"
    },
    {
        category: 'Learn',
        name: "CharmHealthApps",
        link: "https://www.charmhealth.com/charmhealthapps.html"
    },
    {
        category: 'Learn',
        name: "API Program",
        link: "https://www.charmhealth.com/resources/ehr-api-program.html"
    },
    {
        category: 'Learn',
        name: "Meaningful Use 2015",
        link: "https://www.charmhealth.com/ehr/meaningful-use-certified-ehr.html"
    },
    {
        category: 'Learn',
        name: "News Room",
        link: "https://www.charmhealth.com/ehr/ehr-trade-shows.html"
    },
    {
        category: 'Learn',
        name: "Testimonials",
        link: "https://www.charmhealth.com/ehr/testimonial.html"
    }
];

export const buttonLabels = [
    { label: "Popular", urlLabel: "popular", number: null },
    { label: "Billers", urlLabel: "billers", number: 1, background: "#EE8493" },
    { label: "Billing Tools", urlLabel: "billing-tools", number: 2, background: "#FEFDE5" },
    { label: "Consultants", urlLabel: "consultants", number: 3, background: "#A3AAF9" },
    { label: "CRMs", urlLabel: "crms", number: 4, background: "#F2BCC2" },
    { label: "Developers", urlLabel: "developers", number: 15, background: "#C1E5FC" },
    { label: "Devices", urlLabel: "devices", number: 5, background: "#B9DBCA" },
    { label: "Health Information Exchange", urlLabel: "health-information-exchange", number: 16, background: "#F3F1E8" },
    { label: "Marketing", urlLabel: "marketing", number: 14, background: "#DAD8B4" },
    { label: "Patient Engagement", urlLabel: "patient-engagement", number: 7, background: "#F7D5B8" },
    { label: "Remote Patient Monitoring", urlLabel: "remote-patient-monitoring", number: 8, background: "#F7D5B8" },
    { label: "Supplement Dispensary", urlLabel: "supplement-dispensary", number: 9, background: "#C0BBDD" },
    { label: "Tech Led Innovations", urlLabel: "tech-led-innovations", number: 11, background: "#F7D5B8" },
    { label: "Transcription", urlLabel: "transcription", number: 10, background: "#FBE6D1" },
    { label: "Venture Capital / Incubator", urlLabel: "venture-capital-incubator", number: 12, background: "#82C0E6" },
    { label: "Workflow & Productivity", urlLabel: "workflow-productivity", number: 13, background: "#DBD7F2" },
    { label: "All", urlLabel: "all", number: null },
];

export const availableCategories = [
    { label: "Billers", urlLabel: "billers", number: 1, background: "#EE8493" },
    { label: "Billing Tools", urlLabel: "billing-tools", number: 2, background: "#FEFDE5" },
    { label: "Consultants", urlLabel: "consultants", number: 3, background: "#A3AAF9" },
    { label: "CRMs", urlLabel: "crms", number: 4, background: "#F2BCC2" },
    { label: "Developers", urlLabel: "developers", number: 15, background: "#C1E5FC" },
    { label: "Devices", urlLabel: "devices", number: 5, background: "#B9DBCA" },
    { label: "Health Information Exchange", urlLabel: "health-information-exchange", number: 16, background: "#F3F1E8" },
    { label: "Marketing", urlLabel: "marketing", number: 14, background: "#DAD8B4" },
    { label: "Patient Engagement", urlLabel: "patient-engagement", number: 7, background: "#F7D5B8" },
    { label: "Remote Patient Monitoring", urlLabel: "remote-patient-monitoring", number: 8, background: "#F7D5B8" },
    { label: "Supplement Dispensary", urlLabel: "supplement-dispensary", number: 9, background: "#C0BBDD" },
    { label: "Tech Led Innovations", urlLabel: "tech-led-innovations", number: 11, background: "#F7D5B8" },
    { label: "Transcription", urlLabel: "transcription", number: 10, background: "#FBE6D1" },
    { label: "Venture Capital / Incubator", urlLabel: "venture-capital-incubator", number: 12, background: "#82C0E6" },
    { label: "Workflow & Productivity", urlLabel: "workflow-productivity", number: 13, background: "#DBD7F2" },
];

export const essentialsCategories = [
    "Billing Tools",
    "Devices",
    "EHR / PM",
    "Lab Integrations",
    "Mobile Apps",
    "Supplement Dispensary",
];

export const hardcodedEssentials = [
    {
        name: "ATHERO",
        description: "Results Only Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",
        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Accu Ref Medical Lab",
        description: "Results Only Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",
        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Elite Clinical Laboratory",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",
        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Clinical Pathology Lab Integrations",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",
        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Redwood Labs",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",
        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Northwest Clinical Laboratory",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",
        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Spencer Hospital Lab",
        description: "Results Only Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "LabCorp",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Mercy Diagnostics",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "West Pacific Medical Laboratory",
        description: "Results Only Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Legacy Laboratory Services",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Health Lab",
        description: "Results Only Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "True Health Diagnostics",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "American Esoteric Lab Integrations",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Boston Heart Diagnostics",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "GenelCD",
        description: "Results Only Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Millennium Health",
        description: "Results Only Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "BioReference Lab",
        description: "Results Only Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "PathGroup",
        description: "Orders & Results Interface.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "WestPac Labs",
        description: "Results Only Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "ACL",
        description: "Results Only Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Quest Diagnostics Lab",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "HealthBridge",
        description: "Results Only Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Interpath Lab",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Clinical Pathology Labs",
        description: "Results Only Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Clinical Labs of Hawaii",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "LabPro",
        description: "Results Only Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "North Memorial Laboratory",
        description: "Results Only Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Access Medical Labs",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Sound Medical Laboratory",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Vibrant America",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Atherotec Lab",
        description: "Results Only Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Mako Medical Lab Integrations",
        description: "Results Only Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Cole Diagnostics",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",

        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Singulex",
        description: "Orders & Results Interface",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/lab_integrations.png",
        category: "Lab Integrations",
        status: "Integrate",
    },
    {
        name: "Bluefin Payment Gateway",
        description: "Get yourself integrated with payment gateway for credit card processing.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/bluefin_payment_gateway.png",
        category: "Billing Tools",
        status: "Integrate",
    },
    {
        name: "E-Claims",
        description: "Get integrated with Optum clearing house for processing your claims.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/eClaims.png",
        category: "Billing Tools",
        status: "Integrate",
    },
    {
        name: "RCM",
        description: "Subscribe for CharmHealth Revenue Cycle Management (RCM) service for effective management of your billing services.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/RCM.png",
        category: "Billing Tools",
        status: "Integrate",
    },
    {
        name: "Quickbooks",
        description: "Enables you to automatically push billing data from CharmHealth to Quickbooks for accounting purpose.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/quickbooks.png",
        category: "Billing Tools",
        status: "Integrate",
    },
    {
        name: "Fullscript",
        description: "Get access to the industry's largest catalog of professional-grade supplements and electronically prescribe them with Fullscript.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/fullscript.png",
        category: "Supplement Dispensary",
        status: "Integrate",
    },
    {
        name: "Wholescripts",
        description: "WholeScripts, a one-stop site for professional-grade nutritional and herbal supplements, powered by XYMOGEN.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/wholescripts.png",
        category: "Supplement Dispensary",
        status: "Integrate",
    },
    {
        name: "VitaminLab",
        description: "VitaminLab empowers health practitioners to create truly personalized supplements tailored to each patient's specific requirements.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/vitaminlab.png",
        category: "Supplement Dispensary",
        status: "Integrate",
    },

    {
        name: "eRx",
        description: "Enable eRx and send prescriptions electronically to over 70000 pharmacies across USA.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/eRx_EPCS.png",
        category: "EHR / PM",
        status: "Integrate",
    },
    {
        name: "EPCS",
        description: "Enable eRx and send prescriptions electronically to over 70000 pharmacies across USA.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/eRx_EPCS.png",
        category: "EHR / PM",
        status: "Integrate",
    },
    {
        name: "Immunization Registry",
        description: "Integrate with state immunization registries to submit patients' current vaccine data and to query their past history.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/immunization_registry.png",
        category: "EHR / PM",
        status: "Integrate",
    },
    {
        name: "PDMP",
        description: "Get integrated with Appriss PMP gateway to show PDMP details of patients within your account.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/pdmp.png",
        category: "EHR / PM",
        status: "Integrate",
    },
    {
        name: "Telehealth",
        description: "Perform video consultations with your patients.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/telehealth.png",
        category: "EHR / PM",
        status: "Integrate",
    },
    {
        name: "AAP Templates",
        description: "Use AAP Bright Futures Templates, Questionnaires and Handouts for documenting patient visits.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/aap_templates.png",
        category: "EHR / PM",
        status: "Integrate",
    },
    {
        name: "Charm AI Scribe",
        description: "Increase your productivity and spend more time with your patients while our AI assistant takes care of the documentation.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/charm_ai_assist.png",
        category: "EHR / PM",
        status: "Integrate",
    },
    {
        name: "Text / Voice Notifications",
        description: "Send notifications to patients regarding appointments, vaccine reminders, lab results, documents shared, etc.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/text_voice_notifications.png",
        category: "EHR / PM",
        status: "Integrate",
    },
    {
        name: "Fax",
        description: "Get integrated with secure Fax gateway to send and receive faxes within your CharmHealth account.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/fax.png",
        category: "EHR / PM",
        status: "Integrate",
    },
    {
        name: "Scanner",
        description: "Connect with your scanner to upload patient documents into your CharmHealth account.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/scanner.png",
        category: "EHR / PM",
        status: "Integrate",
    },
    {
        name: "E-Commerce",
        description: "Enables you to sell products to patients through CharmHealth Patient Portal.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/eCommerce.png",
        category: "EHR / PM",
        status: "Integrate",
    },
    {
        name: "Direct Message",
        description: "A HIPAA-compliant secure web e-mail designed for transmitting patient health information to providers outside your practice.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/direct_message.png",
        category: "EHR / PM",
        status: "Integrate",
    },

    {
        name: "CharmConnect",
        description: "A HIPAA compliant secure instant messaging platform that helps you to seamlessly interact with your practice members and patients.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/charm_connect.png",
        category: "Mobile Apps",
        status: "Integrate",
    },
    {
        name: "Custom Branded App",
        description: "Provide custom branded patient portal app to patients with your practice name and logo.",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/custom_branded_patient_app.png",
        category: "Mobile Apps",
        status: "Integrate",
    },
    {
        name: "Health o meter 500KL",
        description: "Eye-level digital platform scale with built-in height rod",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/external_devices.png",
        category: "Devices",
        status: "Integrate",
    },
    {
        name: "Health o meter 600KL",
        description: "Heavy duty, eye level, digital scale with integral digital height rod ",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/external_devices.png",
        category: "Devices",
        status: "Integrate",
    },
    {
        name: "Health o meter 1100KL",
        description: "Digital platform scale with extra wide handrails and digital height rod",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/external_devices.png",
        category: "Devices",
        status: "Integrate",
    },
    {
        name: "Tanita TBF-300",
        description: "Connect with scales to auto-transmit health parameters to CharmHealth",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/external_devices.png",
        category: "Devices",
        status: "Integrate",
    },
    {
        name: "Tanita TBF-310",
        description: "Connect with scales to auto-transmit health parameters to CharmHealth",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/external_devices.png",
        category: "Devices",
        status: "Integrate",
    },
    {
        name: "Tanita TBF-410",
        description: "Connect with scales to auto-transmit health parameters to CharmHealth",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/external_devices.png",
        category: "Devices",
        status: "Integrate",
    },
    {
        name: "Tanita DC-430U",
        description: "Integrates cutting-edge bioelectric impedance technology to enhance the accuracy of15 full body composition measurements",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/external_devices.png",
        category: "Devices",
        status: "Integrate",
    },
    {
        name: "Valhalla Body Composition Scale",
        description: "Elevates professional body composition testing by providing unparalleled ease-of-use, instant display of 6 core metrics",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/external_devices.png",
        category: "Devices",
        status: "Integrate",
    },
    {
        name: "InBody-570",
        description: "Explore devices designed to deliver accurate, quick, and non-invasive assessments to provide you with insightful and actionable data",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/external_devices.png",
        category: "Devices",
        status: "Integrate",
    },
    {
        name: "InBody-770",
        description: "Explore devices designed to deliver accurate, quick, and non-invasive assessments to provide you with insightful and actionable data",
        thumbnail: "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/EssentialsThumbnails/external_devices.png",
        category: "Devices",
        status: "Integrate",
    },
];

export const essentialsNameMapping = {
    "Lab Integrations": {
        name: "lab_integrations",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=lab_integrations"
    },
    "Telehealth": {
        name: "telehealth",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=telehealth",
        id: "1633",
    },
    "Immunization Registry": {
        name: "immunization_registry",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=immunization_registry"
    },
    "AAP Templates": {
        name: "aap_templates",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=aap_templates"
    },
    "Text / Voice Notifications": {
        name: "text_voice_notifications",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=text_voice_notifications"
    },
    "Fax": {
        name: "fax",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=fax"
    },
    "Scanner": {
        name: "scanner",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=scanner"
    },
    "Bluefin Payment Gateway": {
        name: "bluefin",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=bluefin",
        id: "1534",
    },
    "E-Claims": {
        name: "eclaims",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=eclaims"
    },
    "RCM": {
        name: "rcm",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=rcm"
    },
    "Fullscript": {
        name: "fullscript",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=fullscript",
        id: "1563",
    },
    "E-Commerce": {
        name: "ecommerce",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=ecommerce"
    },
    "CharmConnect": {
        name: "charm_connect",
        redirect: " https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=charm_connect"
    },
    "Quickbooks": {
        name: "quick_books",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=quick_books",
        id: "1602",
    },
    "External Devices": {
        name: "external_devices",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=external_devices"
    },
    "Direct Message": {
        name: "direct_message",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=direct_message"
    },
    "Custom Branded App": {
        name: "custom_branded_patient_app",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=custom_branded_patient_app"
    },
    "Wholescripts": {
        name: "wholescripts",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=wholescripts",
        id: "1630",
    },
    "VitaminLab": {
        name: "vitaminlab",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=vitaminlab",
        id: "1626",
    },
    "PDMP": {
        name: "pdmp",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=pdmp"
    },

    "eRx": {
        name: "erx",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=erx"
    },
    "EPCS": {
        name: "epcs",
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=epcs"
    },
    "Charm AI Assist": {
        name: "charm_ai_scribe",
        redirect: "https://ehr.charmtracker.com/ehr/physician/extensionSettings.do?method=extensionHome&EXTENSION_ID=101000666053999&FROM_PAGE=PLUGINS"
    },
};

export const AASEssentials = {
    "1633": {
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=telehealth",
    },
    "1534": {
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=bluefin",
    },
    "1563": {
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=fullscript",
    },
    "1602": {
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=quick_books",
    },
    "1630": {
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=wholescripts",
    },
    "1626": {
        redirect: "https://ehr.charmtracker.com/ehr/physician/mySpace.do?ACTION=PLUGIN_REDIRECT&PLUGIN_NAME=vitaminlab",
    },
}

export const CHICParticipants = [
    {
        "name": "Cerevu",
        "thumbnail": "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/CHICThumbnails/cerevu.jpg",
        "id": "1540"
    },
    {
        "name": "Atapir",
        "thumbnail": "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/CHICThumbnails/Atapir.jpg",
        "id": "1530"
    },
    {
        "name": "Mesh AI",
        "thumbnail": "https://charmhealthhub-production.s3.us-east-1.amazonaws.com/uploads/1953/product_95/thumbnail.jpg",
        "id": "1592"
    },
    {
        "name": "Histolix",
        "thumbnail": "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/CHICThumbnails/histolix.jpg",
        "id": "1568"
    },
    {
        "name": "Telebionix",
        "thumbnail": "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/CHICThumbnails/telebionix.jpg",
        "id": "1614"
    },
    {
        "name": "Amelia Virtual Care",
        "thumbnail": "https://charmhealthhub-production.s3.us-east-1.amazonaws.com/uploads/1880/product_5/thumbnail.jpg",
        "id": "1526"
    },
    {
        "name": "Skali Inc",
        "thumbnail": "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/CHICThumbnails/skali.jpg",
        "id": "1608"
    },
    {
        "name": "PCOS Sisters Telehealth",
        "thumbnail": "https://charmhealthhub-production.s3.us-east-1.amazonaws.com/uploads/1962/product_106/thumbnail.jpg",
        "id": "1597"
    },
    {
        "name": "LaughMD",
        "thumbnail": "https://charmhealthhub-production.s3.us-east-1.amazonaws.com/uploads/1946/product_84/thumbnail.jpg",
        "id": "1585"
    },
    {
        "name": "Kepler Technologies",
        "thumbnail": "https://charmhealthhub-production.s3.us-east-1.amazonaws.com/uploads/1941/product_78/thumbnail.jpg",
        "id": "1580"
    },
];

export const UpdatedCHICParticipants = [
    {
        "name": "Rubitection",
        "thumbnail": "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/CHICThumbnails/Rubitection.png",
        "description": "Rubitection is an AI assessment and care coordination platform for skin-related and vascular health conditions. Their solution, the Rubitect Assessment System, empowers any caregiver or healthcare professional with confidence in their early  assessment and care management of the skin. The platform consists of an easy- to-use measurement probe and care management software that provides data  needed to personalize care and support prevention in any care environment.",
        "label": "2025 1st Place Winner",
        "website": "https://rubitection.com"
    },
    {
        "name": "Voice Health",
        "thumbnail": "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/CHICThumbnails/VoiceHealth.png",
        "description": "Voice Health is a comprehensive platform for automating patient communication across the entire journey. From intelligent care routing and intake, to reminders, refills, and billing, their platform pluds into your existing workflow and scales with your practice.",
        "label": "2025 2nd Place Winner",
        "website": "https://voicehealth.ai"
    },
    {
        "name": "Thymos Health",
        "thumbnail": "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/CHICThumbnails/ThymosHealth.png",
        "description": "Thymos Health is a virtual, data-driven healthcare service focused on root-cause treatment of autoimmune and complex chronic conditions. Their solution blends expert clinical care with proprietary algorithms to deliver personalized diagnoses and tailored treatment plans, aiming to shorten the typical years-long diagnosis process into weeks and help patients achieve significant symptom relief within months.",
        "label": "2025 3rd Place Winner",
        "website": "https://thymoshealth.com"
    },
    {
        "name": "Pound of Cure Weight Loss",
        "thumbnail": "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/CHICThumbnails/PoundofCure.png",
        "description": "Pound of Cure offers a comprehensive weight-loss platform combining expert- led bariatric surgey, modern GLP-1 medication protocols, and deep nutrition  support, all wrapped into one program. The platform serves people who are ready to move past dieting into real, sustainable change via specialized surgery, medication strategies, and a robust support structure.",
        "label": "2025 Honorable Mention",
        "website": "https://poundofcureweightloss.com"
    },
    {
        "name": "NNPEN",
        "thumbnail": "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/CHICThumbnails/NNPEN.png",
        "description": "NNPEN is the National Nurse Practitioner Entrepreneur Network that was created by Nurse Practitioners to accelerate the number and rate of Nurse Practitioners becoming owners of sustainable businesses. NNPEN is elevating the nursing model to transfotm healthcare delivery systems by creating a financially viable community of Nurse Practitioner Entrepreneurs.",
        "label": "2025 Honorable Mention",
        "website": "https://www.nnpen.org"
    },
    {
        "name": "Veera",
        "thumbnail": "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/CHICThumbnails/Veera.png",
        "description": "Veera's mission is to bring comfort, care, and confidence to pregnancy, breastfeeding and postpartum through thoughtfully designed technology and practical resources. Veera combines innovative hardware with science-backed information and a supportive community, empowering mothers everywhere.",
        "label": "2024 1st Place Winner",
        "website": "https://www.meetveera.com"
    },
    {
        "name": "Grain Fertility",
        "thumbnail": "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/CHICThumbnails/GrainFertility.png",
        "description": "Grain Fertility is a digital support and organization platform designed for people navigating fertility treatments. It lets users securely collect and manage their medical, insurance, and treatment data, while also connecting them to personalized coaching from fertility-nurse experts. The goal: reduce stress, increase transparency, and empower patients through their journey.",
        "label": "2024 2nd Place Winner",
        "website": "https://www.grainfertility.com"
    },
    {
        "name": "Hormony",
        "thumbnail": "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/CHICThumbnails/Hormony.png",
        "description": "Hormony offers a personalized hormone-health solution for women navigating perimenopause. Through at-home saliva-based hormone tests and a companion mobile app, the platform enables you to measure your hormone levels, monitory how they fluctuate over time, and manage symptoms with tailored insights on nutrition, lifestyle, and symptom tracking.",
        "label": "2024 Honorable Mention",
        "website": "https://findhormony.com"
    },
    {
        "name": "Advanced Health Academy",
        "thumbnail": "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/CHICThumbnails/AdvancedHealthAcademy.png",
        "description": "Advanced Health Academy is a health technology platform designed to transform routine blood-test data into actionable insights. Users upload their lab results and receive professional interpretations that go beyond standard normal ranged, focusing instead on optimised biomarkers, organ-level function, and early stage disease detection.",
        "label": "2024 Honorable Mention",
        "website": "https://www.ahealthacademy.com"

    },
    {
        "name": "Molecular You",
        "thumbnail": "https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/CHICThumbnails/MolecularYou.png",
        "description": "Molecular You offers a precision biomarker platform for both individuals and healthcare providers, enabling in-depth analysis of 190+ blood based biomarkers from just one blood sample. Their science backed reports highlight early health risks across dozens of body systems, then translate these into actionable lifestyle, diet, and treatment recommendations.",
        "label": "2024 Honorable Mention",
        "website": "https://www.molecularyou.com"
    }
]

export const vendorFieldsMapping = {
    "company_name": "Vendor Name",
    "vendor_bio": "Vendor Description",
    "address": "Vendor Address",
    "website": "Vendor Website",
    "year_founded": "Year Founded",
    "number_of_employees": "Number of Employees",
    "revenue": "Revenue",
    "service_specialties": "Service Specialties",
    "service_description": "Service Description",
    "serve_plan": "Goal",
    "is_chic_participant": "CHIC",
    "has_api_interest": "API Program Interest",
    "title": "Title",
    "contact_name": "Contact Name",
    "contact_email": "Contact Email",
    "contact_phone_number": "Contact Phone Number",
    "approval_status": "Approval Status",
    "is_active": "Active",
    "date_registered": "Date Registered",
}

export const productFieldsMapping = {
    "banner": "Product Banner",
    "contact_email": "Contact Email",
    "description": "Product Description",
    "essential_redirect": "Essential Redirect",
    "facebook": "Facebook",
    "has_free_trial": "Free Trial",
    "has_free_version": "Free Version",
    "images": "Images",
    "instagram": "Instagram",
    "linkedin": "LinkedIn",
    "name": "Product Name",
    "pricing": "Pricing",
    "privacy_policy": "Privacy Policy",
    "thumbnail": "Product Thumbnail",
    "twitter": "Twitter",
    "website": "Website",
    "videos": "Videos",
    "logo": "Logo",
}

export const sortOptions = ["Newest", "Oldest", "Highest Rating", "Lowest Rating"];

export const adminPortalVendorSortOptions = ["Newest", "Oldest", "Alphabetical (A-Z)", "Alphabetical (Z-A)"];

export const vendorPortalOrderSortOptions = ["Newest Created", "Oldest Created", "Newest Updated", "Oldest Updated", "Practice Name (A-Z)", "Practice Name (Z-A)"];

export const vendorPortalOrdersColumns = [
    {
        key: "id",
        label: "Request ID",
        accessor: order => order.id,
        widthClass: "min-w-[112px] max-w-[112px]",
    },
    {
        key: "practice_name",
        label: "Practice Name",
        accessor: order => order.practice_name,
        widthClass: "min-w-[280px] max-w-[280px]",
    },
    {
        key: "practice_user_email",
        label: "Requester Email",
        accessor: order => order.practice_user_email,
        widthClass: "min-w-[280px] max-w-[280px]",
    },
    {
        key: "product_id",
        label: "Product ID",
        accessor: order => order.product?.id ?? "",
        widthClass: "min-w-[112px] max-w-[112px]",
    },
    {
        key: "product_name",
        label: "Product Name",
        accessor: order => order.product?.name ?? "",
        widthClass: "min-w-[280px] max-w-[280px]",
    },
    {
        key: "status",
        label: "Status",
        accessor: order => order.status,
        widthClass: "min-w-[212px] max-w-[212px]",
    },
    {
        key: "created_at",
        label: "Created At",
        accessor: order => order.created_at,
        widthClass: "min-w-[220px] max-w-[220px]",
    },
    {
        key: "updated_at",
        label: "Last Updated",
        accessor: order => order.updated_at,
        widthClass: "min-w-[220px] max-w-[220px]",
    },
];

export const vendorTracks = [
    {
        title: 'Listed Partner',
        description: 'Gain visibility among thousands of physicians and practices that rely on CharmHealth for their day-to-day operations by becoming a listed partner. All approved vendors have the ability to create a listing of their product or service to appear on CharmHealthHub.\n\nWhile listed partners may not be directly integrated with CharmHealth, your offering will be easily discoverable, allowing users to contact you for collaboration or partnership opportunities.',
        icon: "ListedPartnerIcon"
    },
    {
        title: 'Practice Level Integrator',
        description: 'For vendors aiming to integrate their solution with CharmHealth, the first step is to integrate your solution to an individual practice. This involves enrolling in CharmHealth’s API program and collaborating with the practice that uses our EHR to build and test your integration.\n\nIf you’re not currently working with a CharmHealth practice, becoming a listed partner can help you connect with practices interested in your product and open the door to integration opportunities.',
        icon: "PracticeLevelIntegrationIcon"
    },
    {
        title: 'Fully Integrated Partner',
        description: 'After successfully implementing practice-level integrations, gathering usage information, and receiving feedback, you may be invited to become a fully integrated vendor within the CharmHealth ecosystem.\n\nAs a fully integrated vendor, your solution becomes seamlessly accessible to all CharmHealth users—no additional customization required. Practices can easily activate and use your offering directly within their EHR environment.',
        icon: "FullyIntegratedPartnerIcon"
    }
]

export const testimonialReviews = [
    {
        testimonial: "The CharmHealth-Fullscript integration has greatly improved our clinic’s care by making it easier for patients to access professional-grade supplements, resulting in improved patient satisfaction and better clinical outcomes.",
        headshot: "https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/andre_wong.png",
        name: "Andrew Wong, MD, FACP, IFMCP",
        title: "CEO & Medical Director, Capital Integrative Health"
    },
    {
        testimonial: "With respect to integrated payments with Bluefin and CharmHealth, there's a huge value in having everything in one location. It is just a very intuitive software really speeds up efficiency makes things that much better.",
        headshot: "https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/Sleiman.png",
        name: "Joseph E. Sleiman, MD, FAAFP",
        title: "Founder & CEO, Clinic45"
    },
    {
        testimonial: "It really makes filling prescriptions, refilling prescriptions, much, much easier. From a couple of clicks of the button, when I’m in the patient encounter, I can pull up a medication, whether it’s controlled or not, and send it on its way to the pharmacy, because at this point, all pharmacies participate in e-prescription. So that is a huge part of the workflow.",
        headshot: "https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/dude.png",
        name: "Dr. Reza Hosseini Ghomi, MD, MSE",
        title: "CTO & Co-Founder of Frontier Psychiatry"
    },
]